import { useChats } from '@sqior/react/uiadvanced';
import ChatList from '../chat-list/chat-list';
import styles from './chat-page.module.css';

export interface ChatPageProps {
  type?: 'support' | 'all';
}

export function ChatPage({ type }: ChatPageProps) {
  const { chats } = useChats({ type });

  return (
    <div className={styles['container']}>
      <ChatList chats={chats} />
    </div>
  );
}

export default ChatPage;
